<template>

    <div class="splash_upcoming">
        <img src="./assets/images/bg-wingtip-appiarius.jpg" v-if="!hideImage"/>

        <div class="text-box">
            <h6>Accommodations</h6>

            <span><i>We've reserved discounted rooms at the 21c Hotel. Rides to the venue will not be provided so please let us know if you need help with transportation.</i></span>

            <br />

            <div class="hotel-group">
                <a href="https://gc.synxis.com/rez.aspx?Hotel=56599&Chain=7748&arrive=5/25/2018&depart=5/28/2018&adult=1&child=0&group=AWWED2018" target="_blank">
                    <img src="./assets/images/21c.jpg" />
                </a>
                <a 
                    class="link-style"
                    href="https://gc.synxis.com/rez.aspx?Hotel=56599&Chain=7748&arrive=5/25/2018&depart=5/28/2018&adult=1&child=0&group=AWWED2018"
                    target="_blank">twenty-one c museum hotel<br/>
                    [click to reserve with discounted price]
                </a>
                <span><i>21C is an art museum and a hotel located in a historical building in the heart of downtown Cincinnati.
                    <br />
                (15 - 20 minute drive to the venue)</i></span>
            </div>
        </div>

        <a name="registry" id="registry"></a>
        <hr class="splashDivide"/>

        <div class="text-box">
            <h6>Registry</h6>

            <span><i>Your presence at our celebration is a beautiful gift to us and we expect nothing more!

            If you're feeling the tradition, we will be beyond grateful for your generosity.</i></span>

            <br />


            <a class="button-style" 
                href="https://www.amazon.com/wedding/share/unionofaries"
                target="_blank">amazon
            </a>

            <a class="button-style"
                href="https://www.anthropologie.com/registry/listing?registryId=ZMJHZTI0ZDC5"
                target="_blank">anthropologie
            </a>

            <a class="button-style" 
                href="https://www.paypal.com/pools/c/7ZN399ABSA"
                target="_blank">
                honeymoon fund
            </a>

        </div>

    </div>

</template>

<script>
export default {
    name: 'accomodations',
    props: ['hideImage'],
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/Accomodations.vue